export default __webpack_public_path__ + "static/media/platforms-min.a502ca8a.png";